import {PartnerSummaryModel} from '../../../../../partner/common/api/model/partnerSummary.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {ConsultationSummaryModel} from '../../../../consultation/consultation/api/model/consultationSummary.model';

export class MedicalRecordSportModel { // extends SummaryModel{
    id: number;
    partner: PartnerSummaryModel;
    consultation: ConsultationSummaryModel;
    sport: LovValueSummary;
    type: LovValueSummary;
    frequency: LovValueSummary;
    flooring: LovValueSummary;
    startYear: number;
    endYear: number;
    comment: string;

    get periodAsLabel(): string {
        let period = '';
        if (this.startYear && this.endYear) {
            period += 'De ' + this.startYear;
        } else if (this.startYear && ! this.endYear) {
            period += 'Depuis ' + this.startYear;
        }


        if (this.endYear) {
            if (period?.length > 0) {
                period += ' à ' + this.endYear;
            }else {
                period += 'Jusqu\'en ' + this.endYear;
            }
        }
        if (period?.length === 0) {
            return undefined;
        }
        return period;
    }
}
